import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import { PAYOUT_HISTORY_ROUTES } from '../constants/routes.constants';
import { appLayoutRoute } from '../../layout';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { hasRole } from '@/shared/utils/rbac.utils';
import ROUTE_CONSTANTS from '@/shared/constants/route.constants';
import { ROLES } from '@/features/rbac';

const checkTenantPayoutAccess = () => {
  const user = useAuthStore.getState().user;
  if (
    hasRole(user, ROLES.SUPER_ADMIN) ||
    (!hasRole(user, ROLES.TENANT_ADMIN) && !hasRole(user, ROLES.POWER_ADMIN))
  ) {
    throw redirect({ to: ROUTE_CONSTANTS.ROOT, replace: true });
  }
};

const payoutHistoryListRoute = createRoute({
  path: PAYOUT_HISTORY_ROUTES.LIST,
  getParentRoute: () => appLayoutRoute,
  component: lazyRouteComponent(() =>
    import('../pages').then(m => ({ default: m.PayoutHistoryPage }))
  ),
  beforeLoad: async () => {
    checkTenantPayoutAccess();
  },
});

export const payoutHistoryRoutes = [payoutHistoryListRoute];

export default payoutHistoryRoutes;
